/**
 * Persistent token storage — backed by localStorage AND Telegram CloudStorage
 * (when available). CloudStorage survives WebView cache clears and syncs
 * across every device the user has Telegram on — much more reliable than
 * localStorage alone in a Mini App.
 */
const KEY = 'auth_token';

const getTG = () => (typeof window !== 'undefined' ? window.Telegram?.WebApp : null);

/** Read from localStorage synchronously, then async top-up from CloudStorage. */
export const loadToken = () => {
  try {
    const t = localStorage.getItem(KEY);
    if (t) return t;
  } catch { /* ignore */ }
  return null;
};

/** Async lookup in Telegram CloudStorage — resolves with value or null. */
export const loadTokenFromCloud = () =>
  new Promise((resolve) => {
    const tg = getTG();
    if (!tg?.CloudStorage?.getItem) return resolve(null);
    try {
      tg.CloudStorage.getItem(KEY, (err, value) => resolve(err ? null : value || null));
    } catch { resolve(null); }
  });

export const saveToken = (token) => {
  if (!token) return;
  try { localStorage.setItem(KEY, token); } catch { /* ignore */ }
  const tg = getTG();
  if (tg?.CloudStorage?.setItem) {
    try { tg.CloudStorage.setItem(KEY, token, () => {}); } catch { /* ignore */ }
  }
};

export const clearToken = () => {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
  const tg = getTG();
  if (tg?.CloudStorage?.removeItem) {
    try { tg.CloudStorage.removeItem(KEY, () => {}); } catch { /* ignore */ }
  }
};
